import {ActionList, ActionMenu} from '@primer/react'
import {AlphaLabel} from '@github-ui/lifecycle-labels/alpha'
import {ArrowUpRightIcon, CommentIcon, RocketIcon} from '@primer/octicons-react'

interface HeaderFeedbackMenuProps {
  className?: string
}

export function HeaderFeedbackMenu({className}: HeaderFeedbackMenuProps) {
  return (
    <ActionMenu>
      <ActionMenu.Button variant="invisible" size="medium" className={className}>
        <AlphaLabel />
      </ActionMenu.Button>
      <ActionMenu.Overlay>
        <ActionList>
          <ActionList.LinkItem
            href="https://gh.io/prs-modern-header-changelog"
            target="_blank"
            rel="noopener noreferrer"
          >
            <ActionList.LeadingVisual>
              <RocketIcon />
            </ActionList.LeadingVisual>
            What&apos;s new
            <ActionList.TrailingVisual>
              <ArrowUpRightIcon />
            </ActionList.TrailingVisual>
          </ActionList.LinkItem>
          <ActionList.LinkItem
            href="https://gh.io/prs-modern-header-feedback"
            target="_blank"
            rel="noopener noreferrer"
          >
            <ActionList.LeadingVisual>
              <CommentIcon />
            </ActionList.LeadingVisual>
            Give feedback
            <ActionList.TrailingVisual>
              <ArrowUpRightIcon />
            </ActionList.TrailingVisual>
          </ActionList.LinkItem>
        </ActionList>
      </ActionMenu.Overlay>
    </ActionMenu>
  )
}
